  // // frontend/src/App.js
  import React, { useState } from 'react';
  import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
  import Header from './components/Header';
  import Footer from './components/Footer';
  import Home from './components/Home';
  import About from './components/About';
  import Project from './components/Project';
  import Gallery from './components/Gallery';
  import DonationCenters from './components/DonationCenters';
  import BankDetails from './components/BankDetails';
  import Contact from './components/Contact';
  import DonationReceipt from './components/DonationReceipt';
  import SharedDonationReceipt from './components/SharedDonationReceipt';
  import DonateModal from './components/DonateModal';
  import TrusteeMandal from './components/TrusteeMandal';
import TermsAndConditions from './components/TermsAndPolicies';
import RefundPolicy from './components/RefundPolicy';
import PrivacyPolicy from './components/PrivacyPolicy';
import ShippingPolicy from './components/ShippingPolicy';
 
  import AlbumDetail from './components/AlbumDetail';
  import Documents from './components/Documents';
import MyDonations from './components/MyDonations';
import PaymentStatus from './components/PaymentStatus';

  function App() {
    const [isDonateModalOpen, setDonateModalOpen] = useState(false);
 
    const openDonateModal = () => setDonateModalOpen(true);
    const closeDonateModal = () => setDonateModalOpen(false);
 
    return (
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/project" element={<Project />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/donation-centres" element={<DonationCenters />} />
              <Route path="/bank-details" element={<BankDetails />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/receipt" element={<DonationReceipt />} />
              <Route path="/receipt-share" element={<SharedDonationReceipt />} />
              <Route path="/trusti-mandal" element={<TrusteeMandal />} />

              {/* Terms & Policies Section */}
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
 
              {/* Dynamic gallery album route */}
              <Route path="/gallery/:slug" element={<AlbumDetail />} />
              {/* Backward-compatible redirects for old gallery URLs */}
              <Route path="/infrastructure" element={<Navigate to="/gallery/infrastructure" replace />} />
              <Route path="/3d-photo" element={<Navigate to="/gallery/3d-photo" replace />} />
              <Route path="/animal-help" element={<Navigate to="/gallery/animal-help" replace />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/my-donations" element={<MyDonations />} />
              {/* PayU payment callback landing page */}
              <Route path="/payment-status" element={<PaymentStatus />} />
            </Routes>
          </div>
 
          <Footer />
 
          {/* Floating Donate Button */}
          <div className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50">
            <button
              onClick={openDonateModal}
              className="bg-primary hover:bg-secondary text-white font-bold py-3 px-6 rounded shadow-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
              aria-label="Donate Now"
            >
              Donate Now
            </button>
          </div>
 
          {/* Donate Modal */}
          {isDonateModalOpen && <DonateModal onClose={closeDonateModal} />}
        </div>
      </Router>
    );
  }
 
  export default App;
